const scrollToTopButton = document.querySelector('.scroll-to-top-button');

if (scrollToTopButton) {
    scrollToTopButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        scrollToTopButton.blur();
    });
}

window.addEventListener(
    'scroll',
    () => {
        if (window.scrollY > 500) {
            scrollToTopButton.classList.add('scroll-to-top-button--active');
        } else {
            scrollToTopButton.classList.remove('scroll-to-top-button--active');
        }
    },
    { passive: true }
);
